import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  returnsPanelHeader: {
    defaultMessage: 'RETURNS',
    description: 'Header for a panel that displays a list of returns',
    id: 'UhH4KG',
  },
});
